<div class="container">
    <div class="not-found-404">
        <h1>404</h1>
        <p>OOOPS! Não tem nada aqui :(</p>
    </div>
</div>
